import { Dispatch } from 'react';

export const savePoints =
  (onSave: Dispatch<React.SetStateAction<any>>) =>
  ({
    offerId,
    amount,
    fraction,
  }: {
    offerId?: string;
    amount: number;
    fraction: number;
  }) => {
    if (!offerId) return;

    const key = `${offerId}_${parseFloat(amount.toString()).toFixed(2)}`;

    onSave((prevPoints: any) => ({
      ...prevPoints,
      [key]: fraction,
    }));
  };
